import React from 'react';
/*
 * Bronson Heading component.
 */
export function Heading({ level, children, testId, ...otherProps /* in Complex tag name tag */ }) {
    const CustomTagHeadingsLevel = `h${level}`;
    return (React.createElement(CustomTagHeadingsLevel, { ...otherProps, "data-testid": testId }, children));
}
